import styled from 'styled-components';

export const BottomContainer = styled.div`
  background: ${({ theme }) => theme.colors.white};

  display: flex;
  justify-content: space-between;

  padding: 24px;
  gap: 24px;
  min-height: 96px;

  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  width: 100%;

  z-index: 99;

  box-shadow: ${({ theme }) => theme.commoms.boxShadow2};

  .hefesto-button {
    min-height: 48px;
    min-width: 48px;
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.laptopM}) {
    flex-direction: column;
  }
`;

export const BottomSummary = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

export const BottomButtons = styled.div`
  display: flex;
  gap: 24px;

  & > button {
    width: 270px;
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.laptopM}) {
    justify-content: space-between;
  }
`;
